import { render, staticRenderFns } from "./admin-referral-employees.vue?vue&type=template&id=2c62d032&scoped=true"
import script from "./admin-referral-employees.vue?vue&type=script&lang=js"
export * from "./admin-referral-employees.vue?vue&type=script&lang=js"
import style0 from "./admin-referral-employees.vue?vue&type=style&index=0&id=2c62d032&prod&lang=scss"
import style1 from "./admin-referral-employees.vue?vue&type=style&index=1&id=2c62d032&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c62d032",
  null
  
)

export default component.exports